import { useEffect } from "react";

function useInfiniteMonths(loadMoreRef, setMonths, getNextMonth) {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setMonths((currentMonths) => {
            const lastMonth =
              currentMonths[currentMonths.length - 1];

            return [
              ...currentMonths,
              getNextMonth(lastMonth),
            ];
          });
        }
      },
      {
        rootMargin: "500px",
      }
    );

    const element = loadMoreRef.current;

    if (element) {
      observer.observe(element);
    }

    return () => {
      if (element) {
        observer.unobserve(element);
      }
    };
  }, []);
}

export default useInfiniteMonths;